import { Box } from "@mui/material"
import { If, Else } from "lib/@components/switch"
import { BadgeLabel } from "routes/regime/plugins/regime-title/badge-label"
import { regimeStatusSx } from "routes/regime/regime-status-pill"
import { RegimeItemTitle } from "slot-definitions"

export function RegimeStateBadge({ item }) {
    const hasState = !!(item.$?.hasLive || item.$?.hasReady || item.$?.hasReview)

    return (
        <If value={hasState}>
            <RegimeItemTitle.Slot regime={item} />
            <Else>
                <Box sx={{ zoom: 0.8 }}>
                    <BadgeLabel sx={regimeStatusSx.draft} badgeContent="Draft" />
                </Box>
            </Else>
        </If>
    )
}
